export default class FocusPath {
  constructor() {
    this.active = false;
    this.svg = null;
    this.prev = null;
    this.handler = null;
    this.cleanup = null;
  }

  enable() {
    if (this.active) return;
    this.active = true;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('a11y-focus-path');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`);
    document.body.appendChild(svg);
    this.svg = svg;

    this.handler = (e) => {
      const rect = e.target.getBoundingClientRect();
      const current = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      
      if (this.prev) {
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', this.prev.x);
        line.setAttribute('y1', this.prev.y);
        line.setAttribute('x2', current.x);
        line.setAttribute('y2', current.y);
        svg.appendChild(line);
        if (svg.childNodes.length > 10) svg.removeChild(svg.firstChild);
      }
      this.prev = current;
    };

    const handleResize = () => {
      svg.setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`);
    };

    document.addEventListener('focusin', this.handler);
    window.addEventListener('resize', handleResize);
    
    this.cleanup = () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('focusin', this.handler);
    };
  }

  disable() {
    if (!this.active) return;
    if (this.cleanup) this.cleanup();
    this.svg?.remove();
    this.svg = null;
    this.prev = null;
    this.active = false;
  }
}
